import { defineFcm } from '../shared/factory';

export const FCM_SIGN_INTENT_VALID_SAMPLE_RATE = defineFcm('sign_intent_valid_sample_rate')
	.asNumber()
	.withDefault(15)
	.toConfig();
